"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerEmitter = void 0;
require("./event-target-polyfill");
class PlayerEmitter extends EventTarget {
    dispatchSeek(frame) {
        this.dispatchEvent(new CustomEvent('seeked', {
            detail: {
                frame,
            },
        }));
    }
    dispatchPause() {
        this.dispatchEvent(new CustomEvent('pause'));
    }
    dispatchPlay() {
        this.dispatchEvent(new CustomEvent('play'));
    }
    dispatchEnded() {
        this.dispatchEvent(new CustomEvent('ended'));
    }
    dispatchError(error) {
        this.dispatchEvent(new CustomEvent('error', {
            detail: {
                error,
            },
        }));
    }
}
exports.PlayerEmitter = PlayerEmitter;
//# sourceMappingURL=event-emitter.js.map